import {isEmpty} from "@/utils/global-functions";

export default function ContactAdvantages({data = {}}) {

    const {contact_middle_section = {}} = data &&  !isEmpty(data.data) ? data.data : {};

    // LOCAL_IMAGE_URL+"laptop-bg-2.webp"

    return (
        <section className="container mt-[4.375rem]">
            <div
                className="relative w-full rounded-[2.25rem] pt-12 lg:pt-[4.375rem] pb-14 lg:pb-16 lg:px-28 px-3.5 overflow-hidden text-white bg-no-repeat bg-cover bg-center"
                style={{backgroundImage: `url('${contact_middle_section ? contact_middle_section.image : ""}')`}}>
                    <span className="w-full h-full absolute top-0 left-0"
                          style={{background: "linear-gradient(225deg, rgba(26,23,34,0.91) 20%, rgba(50,46,62,0.87) 100%)"}}/>
                <div className="relative">
                    <h2 className="text-center font-extrabold text-lg lg:text-xl">{contact_middle_section?.title}</h2>
                    <p className="lg:text-center mt-5 pol-leading-lg text-justify">
                        {contact_middle_section?.text}
                    </p>
                </div>
            </div>
        </section>
    )
}
